import React, {useEffect, useState} from "react";
import CompanyForm from "../forms/CompanyForm";
import PropTypes from "prop-types";

// todo
//  get company from MCC/Ad Seller
//  ?set company whenever existing step i.e. swipe or tab click
//      ? prevent leaving if not valid
//      ? abandoned changes
//      ? Auto submit i.e. validate

export default function StepOne({setCompany, done, ...props}){

    const [key, setKey] = useState(0);

    useEffect(()=>{
        setKey(k=>k+1);
        // force a remount and resetting of initial values
    },[props.company]);

    return (
        <CompanyForm
            key={key}
            allowSubmitNoTouch={true}
            allowSubmitWithErrors={true}
            onSubmit={values=>{
                setCompany(values);
                done();
            }}
            onError={(err,values)=>{
                console.dir(values);
                setCompany(values)}}
            showReset={true}
            submitNotVisible={true}
            {...props}  //company,  isVisible
        />
    );
}
StepOne.propTypes = {
    setCompany: PropTypes.func.isRequired
};
